import React from "react";
import { ItemContainer, PageContainer } from "../survey-tools/ui-components/containers";
import { Typography, Button } from "@mui/material";
import { connect } from 'react-redux';
import { nextTask } from '../study-logic/study-redux-slice';

const handleComplete = () => {
    // Redirect to the Prolific completion URL
    window.location.href = "https://app.prolific.com/submissions/complete?cc=C6JFALKL";
};

export default function Debrief() {
    return (
        <PageContainer>
            <ItemContainer>
                <div>
                    <Typography variant="h4" style={{ textAlign: 'center' }} gutterBottom>
                        Debrief
                    </Typography>
                    <Typography gutterBottom>
                        Thank you for participating in today’s study. Our research depends entirely on volunteers, such as yourself, and we appreciate your being willing to commit time and energy to this study.
                    </Typography>
                    <div style={{ height: '10px' }}></div>
                    <Typography gutterBottom>
                        This survey is part of a larger study on how our emotional experiences influence how our thoughts wander. Your participation will help us learn more about how our emotions influence how the mind moves from one thought to the next.
                    </Typography>
                    <div style={{ height: '10px' }}></div>
                    <Typography gutterBottom>
                        If you have any questions or comments that you would like to share, or if you would like to receive a report of this research when it is completed (or a summary of the findings), please contact Faustine Corbani (faustine@princeton.edu).
                    </Typography>
                    <div style={{ height: '10px' }}></div>
                    <Typography gutterBottom>
                        If you have concerns about your rights as a participant in this experiment, please contact the Office of Research Integrity and Assurance, Human Research Protection Program, Assistant Director. Phone: (609) 258-0865. Email: irb@princeton.edu.
                    </Typography>
                    <div style={{ height: '10px' }}></div>
                    <Typography gutterBottom>
                        Please do not disclose the research procedures to anyone who might participate in this study, as this could affect the results of the study. Thank you for your participation!
                    </Typography>
                    <div style={{ height: '10px' }}></div>
                    <Typography gutterBottom>
                        Please click the button below to the left to submit your responses to this survey and complete your participation.
                    </Typography>
                    <Button 
                        variant="contained" 
                        onClick={handleComplete} 
                        sx={{
                            fontSize: '1rem', // Adjust the font size for a smaller appearance
                            alignSelf: 'flex-end', // Align the button to the right
                            marginTop: 'auto', // Ensure it aligns at the bottom of the container
                        }}
                    >
                        Submit Response
                    </Button>
                </div>
            </ItemContainer>
        </PageContainer>
    );
}
